import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import uniqBy from 'lodash/uniqBy'
import useSlug from '../../../hooks/useSlug'
import { boothDetailSelector, fetchBoothDetail } from '../boothDetailSlice'
import BoothContent from './BoothContent'
import BoothView from './BoothView'
import Loader from '../../../components/Loader'
import BoothStaffs from './BoothContentComponents/BoothStaffs'
import { currentUserSelector } from '../../auth/authSlice'
import useFetchAttendees from '../../attendees/useFetchAttendees'
import useSubscribeAttendees from '../../attendees/useSubscribeAttendees'

const BoothOverview = ({ boothSlug }: { boothSlug: string }) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const eventSlug = useSlug('eventSlug')
    const mapSlug = useSlug('mapSlug')
    const boothDetail = useSelector(boothDetailSelector(boothSlug))
    const staffIds = boothDetail?.data?.staff_ids || []
    const currentUser = useSelector(currentUserSelector())
    const staffData = useFetchAttendees(staffIds)
    const userIsStaff = staffIds.includes(currentUser.id)
    const staffs = uniqBy([...staffData, userIsStaff && currentUser].filter((v) => !!v), 'id')

    useSubscribeAttendees(staffIds)

    // Make sure the mapSlug is valid for the booth
    useEffect(() => {
        if (
            boothDetail.status === 'succeeded'
            && history.location.pathname.includes('/:mapSlug/')
        ) {
            const newUrl = history.location.pathname.replace(
                '/:mapSlug/',
                `/${boothDetail.data.map_slug}/`,
            )
            history.replace(newUrl)
        }
    }, [boothDetail, mapSlug, history])

    useEffect(() => {
        if (boothDetail.status === 'idle') {
            dispatch(fetchBoothDetail({ eventSlug, boothSlug }))
        }
    }, [boothDetail, eventSlug, boothSlug, dispatch])

    if (boothDetail.status === 'loading') {
        return <Loader />
    }

    return boothDetail.data
        ? (
            <>
                <BoothView booth={boothDetail.data} />
                <BoothStaffs boothDetail={boothDetail.data} staffs={staffs} />
                <BoothContent boothDetail={boothDetail.data} staffs={staffs} />
            </>
        )
        : null
}

export default BoothOverview
